import { HStack } from '@sgme/ui';
import type { PropsWithChildren, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl.ts';

export type GrowItemProps = {
  labelId: IntlMessageId;
  'data-e2e'?: string;
  'data-e2e-label'?: string;
  labelValues?: Record<string, ReactNode>;
};

export const GrowlItem = (props: PropsWithChildren<GrowItemProps>) => {
  const { labelId, 'data-e2e': dataE2e, 'data-e2e-label': dataE2eLabel, children, labelValues } = props;

  return (
    <HStack horizontalAlignment="full" className="border-bottom py-8px fs-12">
      <span className="text-secondary" data-e2e={dataE2eLabel}>
        <FormattedMessage id={labelId} values={labelValues} />
      </span>

      <span className="text-truncate text-end" data-e2e={dataE2e}>
        {children}
      </span>
    </HStack>
  );
};
